import {ChangeDetectorRef, Component, OnInit} from "@angular/core";
import {LoadingService} from "@ui-kit/framework/util/service/loading.service";
import {Observable} from "rxjs";

@Component({standalone: true, template: ''})
export class LoadingComponent<T = any> implements OnInit {

  loading$: Observable<boolean>;

  constructor(protected loader: LoadingService,
              private cd: ChangeDetectorRef) {
    this.loading$ = this.loader.loading$;
  }

  ngOnInit() {
    this.loader.loading$.subscribe(() => {
      this.cd.detectChanges();
    })
  }
}
